import cardGeneric from 'icon/win10/credit-card-back.svg?component'

import americanExpress from 'icon/office/credit-card-american-express.svg?component'
import dinersClub from 'icon/office/credit-card-diners-club.svg?component'
import jcb from 'icon/office/credit-card-jcb.svg?component'
import mastercard from 'icon/office/credit-card-mastercard.svg?component'
import visa from 'icon/office/credit-card-visa.svg?component'
import discover from 'icon/office/credit-card-discover.svg?component'

import americanExpressAlt from 'icon/win10/credit-card-american-express.svg?component'
import dinersClubAlt from 'icon/win10/credit-card-diners-club.svg?component'
import jcbAlt from 'icon/win10/credit-card-jcb.svg?component'
import mastercardAlt from 'icon/win10/credit-card-mastercard.svg?component'
import visaAlt from 'icon/win10/credit-card-visa.svg?component'
import discoverAlt from 'icon/win10/credit-card-discover.svg?component'

const genericCard = {
  color: cardGeneric,
  mono: cardGeneric,
}

export const getIcon = (key) => ({
  hipercard: genericCard,
  aura: genericCard,
  elo: genericCard,

  discover: {
    color: discover,
    mono: discoverAlt,
  },
  visa: {
    color: visa,
    mono: visaAlt,
  },
  mastercard: {
    color: mastercard,
    mono: mastercardAlt,
  },
  amex: {
    color: americanExpress,
    mono: americanExpressAlt,
  },
  jcb: {
    color: jcb,
    mono: jcbAlt,
  },
  diners: {
    color: dinersClub,
    mono: dinersClubAlt,
  },
}[key] || genericCard)

export const getBrand = (key) => ({
  amex: 'American Express',
  aura: 'Aura',
  diners: 'Diners Club',
  discover: 'Discover',
  elo: 'Elo',
  hipercard: 'hipercard',
  jcb: 'JCB',
  mastercard: 'Mastercard',
  visa: 'Visa',
}[key] || '')

export const creditCardDetails = (key) => {
  const icon = getIcon(key)
  const brand = getBrand(key)

  return { icon, brand }
}

export default creditCardDetails
